export default function Options() {
  return (
    <div
      className={`inline-flex cursor-pointer items-center justify-center gap-8 rounded-full bg-black p-2 transition-transform duration-300 active:scale-75`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
      >
        <path
          d="M8.41146 8.66634C8.77965 8.66634 9.07812 8.36786 9.07812 7.99967C9.07812 7.63148 8.77965 7.33301 8.41146 7.33301C8.04327 7.33301 7.74479 7.63148 7.74479 7.99967C7.74479 8.36786 8.04327 8.66634 8.41146 8.66634Z"
          stroke="#FAFAFA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.0781 8.66634C13.4463 8.66634 13.7448 8.36786 13.7448 7.99967C13.7448 7.63148 13.4463 7.33301 13.0781 7.33301C12.7099 7.33301 12.4115 7.63148 12.4115 7.99967C12.4115 8.36786 12.7099 8.66634 13.0781 8.66634Z"
          stroke="#FAFAFA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.74479 8.66634C4.11298 8.66634 4.41146 8.36786 4.41146 7.99967C4.41146 7.63148 4.11298 7.33301 3.74479 7.33301C3.3766 7.33301 3.07812 7.63148 3.07812 7.99967C3.07812 8.36786 3.3766 8.66634 3.74479 8.66634Z"
          stroke="#FAFAFA"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}
